<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'Uredi dogodek' : 'Dodaj dogodek' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form #eventForm="ngForm">
    <!-- Organisation Type -->
    <div class="form-group mb-3">
      <label for="organisation">Organizacija</label>
      <select
        id="organisation"
        class="form-control"
        name="organisation"
        [(ngModel)]="newEvent.organisationID"
        (change)="onOrganisationChange($event)"
        required
      >
        <option *ngFor="let org of organisations" [value]="org.organisationID">{{ org.name }}</option>
      </select>
    </div>

    <!-- Farm ID (Only shown if Organisation is 'Farm') -->
    <div class="form-group mb-3" *ngIf="isFarmOrganisation(organisationID)">
      <label for="farmID">ID kmetije</label>
      <input
        type="number"
        id="farmID"
        class="form-control"
        name="farmID"
        [(ngModel)]="newEvent.farmID"
        required
      />
    </div>

    <!-- Event Title -->
    <div class="form-group mb-3">
      <label for="title">Naslov dogodka</label>
      <input
        type="text"
        id="title"
        class="form-control"
        name="title"
        [(ngModel)]="newEvent.title"
        required
      />
    </div>

    <!-- Event Description -->
    <div class="form-group mb-3">
      <label for="description">Opis</label>
      <quill-editor
        id="description"
        class="form-control"
        name="description"
        [(ngModel)]="newEvent.description"
      ></quill-editor>
    </div>

    <!-- Event Start Date -->
    <div class="form-group mb-3">
      <label for="start">Začetek</label>
      <input
        type="datetime-local"
        id="start"
        class="form-control"
        name="start"
        [(ngModel)]="newEvent.start"
        (ngModelChange)="formatDate($event, 'start')"
        required
      />
    </div>

    <!-- Event End Date -->
    <div class="form-group mb-3">
      <label for="end">Konec</label>
      <input
        type="datetime-local"
        id="end"
        class="form-control"
        name="end"
        [(ngModel)]="newEvent.end"
        (ngModelChange)="formatDate($event, 'end')"
        required
      />
    </div>

    
    <!-- Event Image Reference -->
    <div class="mb-3">
      <label for="productImage" class="form-label">Slika</label>
      <div class="d-flex align-items-center">
        <fa-icon class="me-3" [icon]="faImage"></fa-icon>
        <input id="uploadImageInput" (change)="onImageUploadChanged($event)" type="file" class="form-control" accept=".png,.jpeg,.jpg">
      </div>
      <img *ngIf="previewImageSrc" class="mt-3 img-thumbnail" [src]="previewImageSrc" style="max-width: 100%;">
    </div>
    
    <!-- Event Color -->
    <div class="form-group mb-3">
      <label for="color">Barva na koledarju</label>
      <input
      type="color"
      id="color"
      class="form-control"
      name="color"
      [(ngModel)]="newEvent.color"
      />
    </div>
    <!-- All Day Event -->
    <div class="form-group mb-3">
      <label for="allDay">Ali poteka cel dan?  </label>
      <input
        type="checkbox"
        id="allDay"
        name="allDay"
        [(ngModel)]="newEvent.allDay"
      />
    </div>
    
    <!-- Notify -->
    <div class="form-group mb-3">
      <label for="notify">Obvesti naročnike?  </label>
      <input
        type="checkbox"
        id="notify"
        name="notify"
        [(ngModel)]="newEvent.notify"
      />
    </div>

    <!-- Submit Button -->
    <button type="button" class="btn btn-primary" (click)="addOrUpdateEvent()">
      {{ isEditMode ? 'Posodobi dogodek' : 'Dodaj dogodek' }}
    </button>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Zapri</button>
</div>
